// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"fe13c802","453":"fb593fe3","543":"5f648b45","698":"a7e3cb1f","766":"2d71d498","837":"febac765","892":"06d33438","910":"fcee24ce","920":"2227358b","929":"3306378b","976":"25be00a9","983":"ea1ff2a2"}[chunkId] + ".chunk.js";
};